export default __webpack_public_path__ + "./image/5ba6d59a4a9f2eec5ef91a5790a4a07f.png";